const monthOptions = [
  { value: 1, label: 'Январь' },
  { value: 2, label: 'Февраль' },
  { value: 3, label: 'Март' },
  { value: 4, label: 'Апрель' },
  { value: 5, label: 'Май' },
  { value: 6, label: 'Июнь' },
  { value: 7, label: 'Июль' },
  { value: 8, label: 'Август' },
  { value: 9, label: 'Сентябрь' },
  { value: 10, label: 'Октябрь' },
  { value: 11, label: 'Ноябрь' },
  { value: 12, label: 'Декабрь' },
];

const sectionConfig = {
  income: {
    title: 'Доходы',
    description: 'Плановые зачисления. Для plan-fact можно привязать и category, и счет зачисления.',
    defaultFrequency: 'monthly',
    defaultSyncToFirefly: false,
  },
  recurring: {
    title: 'Периодические расходы',
    description: 'Регулярные траты. При синхронизации отправляются в Firefly III как subscriptions/bills.',
    defaultFrequency: 'monthly',
    defaultSyncToFirefly: false,
  },
  one_time: {
    title: 'Единоразовые расходы',
    description: 'Разовые события по месяцам. Тоже можно синхронизировать в Firefly III как subscriptions.',
    defaultFrequency: 'once',
    defaultSyncToFirefly: false,
  },
  limit: {
    title: 'Лимиты на расходы',
    description: 'Лимиты расходов. Поддерживают несколько Firefly categories и годовую синхронизацию budget limits.',
    defaultFrequency: 'monthly',
    defaultSyncToFirefly: false,
  },
};

const defaultSyncConfig = {
  sync_mode: 'replace_firefly',
  subscription_sync_mode: 'keep',
  rule_sync_mode: 'replace',
  delete_managed_budgets: false,
  delete_active_subscriptions: false,
};

function createItem(kind, sortOrder) {
  return {
    id: 0,
    budget_id: 0,
    kind,
    frequency: sectionConfig[kind].defaultFrequency,
    name: '',
    amount: '0',
    month: kind === 'one_time' ? 1 : null,
    start_month: null,
    end_month: null,
    firefly_category_id: null,
    firefly_category_ids: [],
    firefly_budget_id: null,
    firefly_account_id: null,
	 income_type: kind === 'income' ? 'salary' : '',
	 income_owner: '',
    firefly_bill_id: null,
    firefly_rule_ids: [],
    create_firefly_bill: kind === 'one_time',
    sync_to_firefly: sectionConfig[kind].defaultSyncToFirefly,
    sort_order: sortOrder,
    last_synced_at: null,
    last_sync_status: '',
    last_sync_summary: '',
  };
}

function createBudgetDraft(year) {
  return {
    budget: {
      id: 0,
      year,
      currency_code: 'RUB',
      notes: 'Структура бюджета основана на файле 2025.xlsx и используется как источник правды для sync в Firefly III.',
    },
    items: [
      createItem('income', 1),
      createItem('recurring', 2),
      createItem('one_time', 3),
      createItem('limit', 4),
    ],
    monthly_plan: [],
    item_summaries: [],
    firefly_syncable: [],
    sync_config: { ...defaultSyncConfig },
    sync_runs: [],
  };
}

export { createBudgetDraft, createItem, defaultSyncConfig, monthOptions, sectionConfig };
